import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {AccordionModule} from 'ngx-bootstrap/accordion';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {RouterModule, Routes} from '@angular/router';
import {LanguageLoader} from './languageLoader';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);


import {DataStorageService} from './data-storage.service';
import {SecurityService} from './security.service';
import {NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {httpInterceptorProviders} from './http-interceptors/index';
import {HttpClientModule} from '@angular/common/http';

import {AppComponent} from './app.component';
import {TopBarComponent} from './top-bar/top-bar.component';
import {LangSwitcherComponent} from './top-bar/lang-switcher/lang-switcher.component';
import {SideBarComponent} from './side-bar/side-bar.component';
import {ContentComponent} from './content/content.component';
import {MyOffersComponent} from './content/my-offers/my-offers.component';
import {NewOfferComponent} from './content/new-offer/new-offer.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {ManagementComponent} from './content/management/management.component';
import {FollowUpComponent} from './content/my-offers/follow-up/follow-up.component';
import {CustomerProfileComponent} from './content/new-offer/customer-profile/customer-profile.component';
import {SelectSolutionComponent} from './content/new-offer/select-solution/select-solution.component';
import {InternetIpworldcomComponent} from './content/new-offer/internet-ipworldcom/internet-ipworldcom.component';
import {InternetCyberlinkComponent} from './content/new-offer/internet-cyberlink/internet-cyberlink.component';
import {PhoneNumbersToBePortedComponent} from './content/new-offer/phone-numbers-to-be-ported/phone-numbers-to-be-ported.component';
import {NewPhoneNumbersComponent} from './content/new-offer/new-phone-numbers/new-phone-numbers.component';
import {PeoplephoneHostedComponent} from './content/new-offer/peoplephone-hosted/peoplephone-hosted.component';
import {NewContactPersonComponent} from './content/new-offer/customer-profile/new-contact-person/new-contact-person.component';
import {BusinessFlatRatesComponent} from './content/new-offer/business-flat-rates/business-flat-rates.component';
import {FlatRateHostedComponent} from './content/new-offer/business-flat-rates/flat-rate-hosted/flat-rate-hosted.component';
import {FlatRateSipTrunkComponent} from './content/new-offer/business-flat-rates/flat-rate-sip-trunk/flat-rate-sip-trunk.component';
import {
  PeoplephoneDevicesDataBaseComponent
} from './content/new-offer/peoplephone-devices-data-base/peoplephone-devices-data-base.component';
import {MyDevicesDataBaseComponent} from './content/new-offer/my-devices-data-base/my-devices-data-base.component';
import {OfferSummaryComponent} from './content/new-offer/offer-summary/offer-summary.component';
import {AvailableComponents} from './side-bar/enumAvailableComponents';
import {AvailableComponentsURLs} from './../enumAvailableComponentsURLs';
import {LoginComponent} from './content/login/login.component';
import {RangeComponent} from './content/new-offer/new-phone-numbers/range/range.component';
import {InternetComponent} from './content/new-offer/internet-ipworldcom/internet/internet.component';
import {CyberInternetComponent} from './content/new-offer/internet-cyberlink/cyber-internet/cyber-internet.component';
import {MybagComponent} from './content/mybag/mybag.component';
import {RangePortedComponent} from './content/new-offer/phone-numbers-to-be-ported/range/range.component';
import {StagesComponent} from './content/my-offers/follow-up/stages/stages.component';
import {ManageMyDevicesComponent} from './content/manage-my-devices/manage-my-devices.component';
import {EditManagementComponent} from './content/management/edit-management/edit-management.component';
import {ConfigService} from './config.service';
import {DeviceListComponent} from './content/management/device-list/device-list.component';
import {DeviceComponent} from './content/management/device-list/device/device.component';
import {FormsModule} from '@angular/forms';
import {DeviceCatalogueComponent} from './content/new-offer/peoplephone-devices-data-base/device-catalogue/device-catalogue.component';
import {
  DeviceForSaleComponent
} from './content/new-offer/peoplephone-devices-data-base/device-catalogue/device-for-sale/device-for-sale.component';
import {MyDeviceListComponent} from './content/manage-my-devices/my-device-list/my-device-list.component';
import {MyDeviceComponent} from './content/manage-my-devices/my-device-list/my-device/my-device.component';
import {EditMyDevicesComponent} from './content/manage-my-devices/edit-my-devices/edit-my-devices.component';
import {MyDevicesCatalogueComponent} from './content/new-offer/my-devices-data-base/my-devices-catalogue/my-devices-catalogue.component';
import {
  MyDeviceForSaleComponent
} from './content/new-offer/my-devices-data-base/my-devices-catalogue/my-device-for-sale/my-device-for-sale.component';
import {PricingService} from './pricing.service';
import {ApiService} from './api.service';
import {ApiFollowUpService} from './apiServices/followUp/api-follow-up.service';
import {ApiOfferService} from './apiServices/offer/api-offer.service';
import {PhoneNumbersToBePortedResolver} from './resolvers/phoneNumbersToBePortedResolver';
import {OfferSummaryResolver} from './resolvers/offerSummaryResolver';
import {FlatRateHostedResolver} from './resolvers/FlatRateHostedResolver';
import {ApiCustomerService} from './apiServices/customer/api-customer.service';
import {FlatRateSipTrunkResolver} from './resolvers/FlatRateSipTrunkResolver';
import {PPHostedResolver} from './resolvers/PPHostedResolver';
import {ApiBagService} from './apiServices/bag/api-bag.service';
import {EuropeanDateFormat} from './ngbDateParserFormatter/europeanDateFormat';
import {FUresolver} from './resolvers/FUresolver';
import {ApiTextService} from './apiServices/text/text.service';
import {NgxSpinnerModule} from 'ngx-spinner';
import {PeoplephoneSiptrunkComponent} from './content/new-offer/peoplephone-siptrunk/peoplephone-siptrunk.component';
import {DisclaimerComponent} from './content/disclaimer/disclaimer.component';
import {CurrencyPipe} from '../pipes/currency.pipe';
import {SafehtmlPipe} from '../pipes/safehtml.pipe';
import {NToBR} from '../pipes/nToBR.pipe';
import {ThreeCXComponent} from './content/new-offer/threeCX/threeCX.component';
import {ThreeCXResolver} from './resolvers/ThreeCXResolver';
import {TeamsComponent} from './content/new-offer/microsoft-teams/teams.component';
import {TeamsResolver} from './resolvers/TeamsResolver';
import {BundleResolver} from './resolvers/BundleResolver';
import {SipTrunkResolver} from './resolvers/SipTrunkResolver';
import {PfBundleComponent} from './content/new-offer/peoplefone-bundle/pfBundle.component';
import {PeoplefoneMittelHostedComponent} from './content/new-offer/peoplefone-mittel-hosted/peoplefone-mittel-hosted.component';
import {AuthLogin} from './authLogin';
import { SettingsComponent } from './settings/settings.component';
import { DatasimComponent } from './content/new-offer/datasim/datasim.component';
import { DatasimResolver } from './resolvers/DatasimResolver';
import { OperatorConnectComponent } from './content/new-offer/operator-connect/operator-connect.component';
import { SbcplusComponent } from './content/new-offer/sbcplus/sbcplus.component';
import { SbcplusResolver } from './resolvers/SbcplusResolver';
import { MobileComponent } from './content/new-offer/peoplefone-mobile/mobile.component';
import { MobileResolver } from './resolvers/MobileResolver';



const appRoutes: Routes = [

  {path: '', component: LoginComponent, canActivate: [AuthLogin]},
  {path: 'login', component: LoginComponent, canActivate: [AuthLogin]},
  {path: 'disclaimer', component: DisclaimerComponent},
  {path: 'myOffers', component: MyOffersComponent, canActivate: [SecurityService]},
  {path: 'followUp', component: FollowUpComponent, canActivate: [SecurityService], resolve: {data: FUresolver}},
  {
    path: AvailableComponentsURLs[AvailableComponents.CustomerProfile],
    component: CustomerProfileComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.WishedSolution],
    component: SelectSolutionComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.PeoplephoneInternetIPworldcom],
    component: InternetIpworldcomComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.PeoplephoneInternetCyberlink],
    component: InternetCyberlinkComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.PhoneNumbersToBePorted],
    component: PhoneNumbersToBePortedComponent,
    canActivate: [SecurityService],
    resolve: {data: PhoneNumbersToBePortedResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.NewPhoneNumbers],
    component: NewPhoneNumbersComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.PeoplephoneSIPTRUNK],
    component: PeoplephoneSiptrunkComponent,
    canActivate: [SecurityService],
    resolve: {data: SipTrunkResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.PeoplephoneHosted],
    component: PeoplephoneHostedComponent,
    canActivate: [SecurityService],
    resolve: {data: PPHostedResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.Datasim],
    component: DatasimComponent,
    canActivate: [SecurityService],
    resolve: {data: DatasimResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.mobile],
    component: MobileComponent,
    canActivate: [SecurityService],
    resolve: {data: MobileResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.PeoplefoneMittel],
    component: PeoplefoneMittelHostedComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.ThreeCX],
    component: ThreeCXComponent,
    canActivate: [SecurityService],
    resolve: {data: ThreeCXResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.PeoplefoneBundle],
    component: PfBundleComponent,
    canActivate: [SecurityService],
    resolve: {data: BundleResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.MicrosoftTeams],
    component: TeamsComponent,
    canActivate: [SecurityService],
    resolve: {data: TeamsResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.OperatorConnect],
    component: OperatorConnectComponent,
    canActivate: [SecurityService],
    //resolve: {data: OperatorConnectResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.SBCplus],
    component: SbcplusComponent,
    canActivate: [SecurityService],
    resolve: {data: SbcplusResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.FlatRateHOSTED],
    component: FlatRateHostedComponent,
    canActivate: [SecurityService],
    resolve: {data: FlatRateHostedResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.FlatRateSIPTRUNK],
    component: FlatRateSipTrunkComponent,
    canActivate: [SecurityService],
    resolve: {data: FlatRateSipTrunkResolver},
    runGuardsAndResolvers: 'always'
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.PeoplephoneDevicesDataBase],
    component: PeoplephoneDevicesDataBaseComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.MyDevicesDataBase],
    component: MyDevicesDataBaseComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.OfferSummary],
    component: OfferSummaryComponent,
    canActivate: [SecurityService],
    resolve: {data: OfferSummaryResolver},
    runGuardsAndResolvers: 'always'
  },


  {
    path: AvailableComponentsURLs[AvailableComponents.Management],
    component: ManagementComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.ManageMyDevices],
    component: ManageMyDevicesComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.EditManagement],
    component: EditManagementComponent,
    canActivate: [SecurityService]
  },
  {
    path: AvailableComponentsURLs[AvailableComponents.EditMyDevices],
    component: EditMyDevicesComponent,
    canActivate: [SecurityService]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [SecurityService]
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [SecurityService]
  }
];

@NgModule({
  declarations: [
    AppComponent,
    TopBarComponent,
    LangSwitcherComponent,
    SideBarComponent,
    ContentComponent,
    MyOffersComponent,
    NewOfferComponent,
    PageNotFoundComponent,
    ManagementComponent,
    FollowUpComponent,
    CustomerProfileComponent,
    SelectSolutionComponent,
    InternetIpworldcomComponent,
    InternetCyberlinkComponent,
    PhoneNumbersToBePortedComponent,
    NewPhoneNumbersComponent,
    PeoplephoneHostedComponent,
    ThreeCXComponent,
    TeamsComponent,
    PfBundleComponent,
    NewContactPersonComponent,
    BusinessFlatRatesComponent,
    FlatRateHostedComponent,
    FlatRateSipTrunkComponent,
    PeoplephoneDevicesDataBaseComponent,
    MyDevicesDataBaseComponent,
    OfferSummaryComponent,
    LoginComponent,
    RangeComponent,
    InternetComponent,
    CyberInternetComponent,
    MybagComponent,
    RangePortedComponent,
    StagesComponent,
    ManageMyDevicesComponent,
    EditManagementComponent,
    DeviceListComponent,
    DeviceComponent,
    DeviceCatalogueComponent,
    DeviceForSaleComponent,
    MyDeviceListComponent,
    MyDeviceComponent,
    EditMyDevicesComponent,
    MyDevicesCatalogueComponent,
    MyDeviceForSaleComponent,
    CurrencyPipe,
    PeoplephoneSiptrunkComponent,
    DisclaimerComponent,
    SafehtmlPipe,
    NToBR,
    PeoplefoneMittelHostedComponent,
    SettingsComponent,
    DatasimComponent,
    OperatorConnectComponent,
    SbcplusComponent,
    MobileComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule.forRoot(
      appRoutes,
      {enableTracing: false}
    ),
    AccordionModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: LanguageLoader
      }
    }),
    NgbModule.forRoot(),
    NgbModule,
    HttpClientModule,
    NgxSpinnerModule
  ],
  providers: [
    {provide: NgbDateParserFormatter, useClass: EuropeanDateFormat},
    {provide: LOCALE_ID, useValue: 'fr-FR'},
    ApiBagService,
    ApiCustomerService,
    ApiFollowUpService,
    ApiOfferService,
    ApiService,
    ConfigService,
    DataStorageService,
    FUresolver,
    PPHostedResolver,
    ThreeCXResolver,
    TeamsResolver,
    BundleResolver,
    FlatRateHostedResolver,
    FlatRateSipTrunkResolver,
    SipTrunkResolver,
    httpInterceptorProviders,
    OfferSummaryResolver,
    PhoneNumbersToBePortedResolver,
    PricingService,
    SecurityService,
    AuthLogin,
    ApiTextService,
    DatasimResolver,
    SbcplusResolver,
    MobileResolver
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts